<template>
  <div >
     <el-form ref="form" :model="formData" :rules="rules" label-width="100px" @submit.native.prevent>
        <el-form-item label="新负责人："  required>
            <div class="check-list" style="width: calc(100% - 20px);">
                <div class="list-box" v-loading="loading">
                    <div>
                        <el-input v-model="searchName" placeholder="请输入负责人姓名精准搜索">
                            <el-button 
                                slot="append" 
                                icon="el-icon-search"
                                @click="handleSearch"
                            />
                        </el-input>
                    </div>
                    <div class="list-radio">
                        <el-radio-group v-model="formData.person_in_charge" @change="handleChange" style="width: 100%;">
                            <div 
                                class="radio-item" 
                                v-for="item in userList" 
                                :key="item.id"
                            >
                                <el-radio :label="item.id">{{item.name}}（{{item.group_name}}）</el-radio>
                            </div>
                        </el-radio-group>
                        <div v-if="!userList.length" class="tac">
                            <span>暂无数据</span>
                        </div>
                    </div>
                </div>
                <div class="result-box"  v-if="checkedUser.id">
                   <div class="result-check">
                        <span>{{ checkedUser.name || '--' }}（ID：{{checkedUser.id}}）</span>
                        <span 
                        class="del"  
                        title="删除"
                        @click="delResultUser"
                        >X</span>
                   </div>
                   <div>
                        <span>邮箱：</span>{{ checkedUser.email || '--' }}
                   </div>
                   <div>
                        <span>部门：</span>{{ checkedUser.group_name || '--' }}
                   </div>
                </div>
            </div>
            
        </el-form-item>
         <el-form-item label="修改产品："   required>
             <el-table
                :data="list"
                :header-cell-style="{background:'#e8eaec',color:'#333'}"
                max-height="300"
                style="width: 100%">
                <el-table-column
                    prop="subproject_name"
                    label="产品名称"
                    show-overflow-tooltip
                    width="220">
                </el-table-column>
                <el-table-column
                    prop="subproject_id"
                    label="ID"
                    show-overflow-tooltip
                    width="200">
                </el-table-column>
                <el-table-column
                    prop="subproject_content"
                    show-overflow-tooltip
                    width="220"
                    label="包名">
                </el-table-column>
                </el-table>
                <!-- <div class="app-list mt6 pl16">
                    <div class="app-item relative ellipsis" v-for="(item,index) in list" :key="index">
                        <p class="ellipsis" :title="item.subproject_name">
                            <span class="item-label">产品名称：</span>
                            {{item.subproject_name||'--'}}
                        </p>
                        <p class="ellipsis pl6" :title="item.subproject_id">
                            <span class="item-label">ID：</span>
                            {{item.subproject_id||'--'}}
                        </p>
                        <p class="ellipsis pl6" :title="item.subproject_content">
                            <span class="item-label">包名：</span>
                            {{item.subproject_content||'--'}}
                        </p>
                    </div>
                </div> -->
            </el-form-item>
     </el-form>
     <div class="tac">
        <el-button @click="$emit('close')">取消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="onSubmit">确定</el-button>
     </div>
  </div>
</template>

<script>
import API from '@/api/baseInfo/customerAppV2';
export default {
    props: [ 'cbs', 'dataSelected' ],
    data() {
        return {
            rules: {
               
            },
            searchName: '',
            list: [...this.dataSelected],
            formData: {
                person_in_charge: '',
            },
            userList: [],
            checkedUser: {},
            loading: false,
            submitLoading: false,
        }
    },
    created() {
    },
    methods: {
        async onSubmit(){
            if(!this.formData.person_in_charge){
                this.$message.error('请选择负责人');
                return;
            }
            try {
                this.submitLoading = true;
                const params ={
                    is_auth_plat_id_id: this.list.map(v=> {
                        return `${v.is_auth}-${v.plat_id}-${v.id}`
                    }),
                    uid: this.formData.person_in_charge
                }
                await API.editCreateUser(params);
                this.$message.success('修改成功');
                this.cbs.onSubmit();
                this.$emit('close');
            } catch (error) {
                this.$message.error(error.info);
            } finally {
                this.submitLoading = false;
            }
        },
        handleSearch(){
            if(!this.searchName){
                this.userList = [];
                return;
            }
            this.getEditUser()
        },
        delResultUser(){
            this.formData.person_in_charge = '';
            this.checkedUser = {};
        },
        handleChange(val,a){
            console.log(val, a);
            const user = this.userList.find(item => item.id == val);
            this.checkedUser = user || {};
        },
        async getEditUser(){
            try {
                this.loading = true;
                const params = {
                    search: this.searchName
                }
                let { data } = await API.getEditUser(params);
                this.userList = data || [];
            } catch (error) {
                this.$message.error(error.info);
            } finally {
                this.loading = false;
            }
        },
        removeApp(item){
            if(this.list.length<=1){
                this.$message.error('至少有一个产品');
                return;
            }
            this.list.splice(this.list.indexOf(item), 1);
        }
    }
}
</script>

<style lang="scss" scoped>
.check-list {
    display: flex;
    border: dashed 1px #ccc;
    padding: 10px;
    .list-box {
        height: 100px;
        border-right: dashed 1px #ccc;
        padding-right: 10px;
        .list-radio {
            height: 160px;
            overflow: auto;
            padding-left: 10px;
            width: 100%;
            .radio-item {
                padding: 6px 0;
            }
        }
    }
    .result-box {
        padding: 0 10px;
        box-sizing: border-box;
    }
    .result-check {
        display: flex;
        justify-content: space-between;
        .del{
            cursor: pointer;
            color: #ec808d;
        }
    }
    >div{
        flex: 1;
    }
}
.app-list{
        min-height: 100px;
        max-height: 300px;
        border: dashed 1px #ccc;
        /*padding: 10px;*/
        /*justify-content: ;*/
        padding-top: 10px;
        overflow-y: auto;
        .item-label {
            display: inline-block;
            width: 60px;
        }
        .app-item{
            border: solid 1px #ccc;
            height: 66px;
            max-height: 300px;
            flex-shrink: 0;
            margin:0 10px 10px 0;
            padding:5px 24px 5px 5px;
            border-radius: 8px;
            &>p{
                line-height: 18px;
                font-size: 12px;
            }
            .close-btn{
                position: absolute;
                right: 0;
                top: 0;
                width: 24px;
                height: 72px;
                line-height: 70px;
                background-color: #ec808d;
                text-align: center;
                cursor: pointer;
                color: #fff;
            }
        }
    }
</style>